import React from "react";
import { useSelector } from "react-redux";
import AreaChart from "../../../../components/charts/areaChart/areaChart";

const YearOverYear = () => {
  const { currencySymbol, recurringRevenuesYearOverYearComparison } = useSelector(
    (state) => state.membershipRevenue.membershipDraft
  );

  return (
    <AreaChart
      chartData={recurringRevenuesYearOverYearComparison}
      width={1350}
      currencySymbol={currencySymbol}
    />
  );
};

export default YearOverYear;
